import React from 'react'
import { FormattedMessage } from 'react-intl'

export const REWARD_BOX_LABEL = (rewardCount) => (
    <FormattedMessage
        id='reward_box.label'
        defaultMessage='И ещё: {rewardCount}'
        values={{
            rewardCount,
        }}
    />
)



// WEBPACK FOOTER //
// ./components/RewardBox/translations.jsx